let EvaluationMixin = {
    props : {
        requestId : {
            required: false
        }
    },
}
export default EvaluationMixin;